import React, { useState } from "react";
import "./TrialCartItem.css";

const TrialCartItem = ({ item, checked, tryAndBuyCartId }) => {
  const {
    productId,
    productName,
    quantity = 1,
    unitPrice = 0,
    totalPrice = 0,
    color = "N/A",
    size = "N/A",
    discountAmount
  } = item;
  

  const [isChecked, setIsChecked] = useState(checked);
    const [loading, setLoading] = useState(false); // Loader state
  


  const handleCheckboxChange = async () => {
    const newCheckedState = !isChecked;
    setIsChecked(newCheckedState);

    const action = newCheckedState ? "add" : "remove";

    try {
      const response = await fetch(
        "https://riymay.com/api/v1/user/try/before/buy/cart",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
          body: JSON.stringify({ tryAndBuyCartId, productId, action }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update cart item");
      }

      const result = await response.json();
    } catch (error) {
      console.error("Error updating cart item:", error);
    }
  };

  return (
    <>
    <div className="trial-cart-item-checkbox-container">
      <div>
      <input
      type="checkbox"
      checked={isChecked}
      onChange={handleCheckboxChange}
      className="trial-cart-item-checkbox"
    />
      </div>
      <div>
      <img
        src={
          item.productUrl
            ? `https://riymay.com/assets/${item.productUrl}`
            : "../../assets/default-product.png"
        }
        alt={productName}
        className="trial-cart-item-image-new"
      />
      </div>
   
    {/* <div className={`trial-cart-item ${isChecked ? "" : "blurred"}`}>
      <img
        src="../../assets/rynobg.png" 
        alt="Logo"
        className="trial-cart-item-logo"
      /> */}
     
      <div className="trial-cart-item-details">
        <div>
        <h3 className="trial-cart-item-price">{productName.length > 20 ? `${productName.substring(0, 20)}...` : productName}</h3>
        <p className="trial-cart-item-price">MRP 
        <span className="trial-cart-item-price-span">₹ {totalPrice.toFixed(1)}</span>
        </p>
        </div>
     <div>
     <p className="trial-cart-item-price">Size: 
      <span className="trial-cart-item-price-span">{size}</span>
      </p>
        <p className="trial-cart-item-price">Quantity: 
        <span className="trial-cart-item-price-span">{quantity}</span>
        </p>
        <p className="trial-cart-item-price">Color: 
        <span className="trial-cart-item-price-span">{color}</span>
        </p>
        <p className="trial-cart-item-price">Unit Price 
       <span className="trial-cart-item-price-span">₹ {unitPrice.toFixed(1)- discountAmount}</span>
       </p>
     <p className="trial-cart-item-price">Applied Discount 
     <span className="trial-cart-item-price-span">₹ {discountAmount}</span>
     </p>
     </div>
       <div>
       
       </div>
       
        
      </div>
    </div>
  {/* </div> */}
  </>
  );
};

export default TrialCartItem;
